import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

//Components

class Login extends Component {
  constructor() {
    super();
    this.state = {
      username:localStorage['AVAFINusername'],
      password:localStorage['AVAFINpassword'],
      domain:"6",
    };
    
    this.handleChangeUsername = this.handleChangeUsername.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeDomain = this.handleChangeDomain.bind(this);
  }

  onClickSend =()=>{
    var user = {
      ObjParamDto:{
        ARCS:0, 
        CD:null, 
        ETAT:0, 
        IDE:this.state.username, 
        LNH:null, 
        Locked:0, 
        MDP:this.state.password, 
        RecordFlag:null, 
        SIG:this.state.domain, 
        SV:0, 
        SessionIDE:this.props.session.Session.SESSION_ID
      }, 
      Session: this.props.session};
  
    this.props.loginTry(user,this.props);
    this.setState({isExpanded: false});
  }

  handleChangeUsername(event) {
    this.setState({username: event.target.value});
  }
  handleChangePassword(event) {
    this.setState({password: event.target.value});
  }
  handleChangeDomain(event) {
    this.setState({domain: event.target.value});
  }


  render() {
    const button = (
      this.props.session == null?
      <div><p>Connecting to AVAFIN, please wait.</p>
      <LinearProgress /></div>
      : 
      <Button variant="contained" className="form-button" color="primary" onClick={this.onClickSend}> Send</Button>
    );


    return (
      <div className="Login View">
        <div className="View-content">
          <div className="login-block">
            <h3>Login pannel</h3>
            <form>
              <div className="form-line">
                <label>UserName</label>
                <input onChange={this.handleChangeUsername} value={this.state.username} placeholder="Username"/>
              </div>
              <div className="form-line">
                <label>Password</label>
                <input type="password" onChange={this.handleChangePassword} value={this.state.password} />
              </div>
              <div className="form-line">
                <label>Domain</label>
                <input onChange={this.handleChangeDomain} value={this.state.domain} placeholder="Domain"/>
              </div>
              {this.props.isError? 
              <div className="form-line error">
                Invalid credential, please check your input.
              </div>
              : null}
              
              <div className="form-button" >
                {button}
              </div>
                
            </form>
          </div>
        </div>
        
      </div>
    );
  }


}
const mapStateToProps = (state) => {    
  return {  
    session : state.apiReducer.session,
    isLogged : state.apiReducer.isLogged,
    isError : state.apiReducer.logginError,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    loginTry: (loginObject,props) => dispatch(repositoryActions.loginTry(loginObject, props)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(Login);